export default "__VITE_ASSET__CjZ3fCc8__"